module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-300italic.c909a3536a5d2c909cb6fe4b87f830e6.woff";